export enum SpecificationType {
    MOSQUITO_NETTING = 'SPECIFICATION_TYPE_MOSQUITO_NETTING',
}
